import { render, staticRenderFns } from "./MembersDay.vue?vue&type=template&id=388db1b5&scoped=true"
import script from "./MembersDay.vue?vue&type=script&lang=js"
export * from "./MembersDay.vue?vue&type=script&lang=js"
import style0 from "./MembersDay.vue?vue&type=style&index=0&id=388db1b5&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "388db1b5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('388db1b5')) {
      api.createRecord('388db1b5', component.options)
    } else {
      api.reload('388db1b5', component.options)
    }
    module.hot.accept("./MembersDay.vue?vue&type=template&id=388db1b5&scoped=true", function () {
      api.rerender('388db1b5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Decoration/PageDecoration/formList/MembersDay.vue"
export default component.exports